"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOverridesFromQueryParams = void 0;
const queryString = require("query-string");
const dvOverridePrefix = 'DV_';
exports.getOverridesFromQueryParams = (flagsToRead, params = window.location.search) => {
    const queryParams = queryString.parse(params);
    const overrides = {};
    Object.entries(flagsToRead).map(entry => {
        const [flagName, flagParser] = entry;
        const override = queryParams[`${dvOverridePrefix}${flagName}`];
        if (override) {
            overrides[flagName] = flagParser(override);
        }
    });
    return Object.keys(overrides).length > 0 ? overrides : undefined;
};
//# sourceMappingURL=queryParamOverrides.js.map